import React, { useState, useRef } from "react";
import { getDistance } from "./functiongeo"; // ta fonction existante
import './App.css';
import MdpProtection from "./mdp";

// --- Trouver les adresses internes les plus proches ---
async function findClosestAddresses(cityName, locations) {
  const response = await fetch(
    `https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&limit=1&countrycodes=fr&q=${encodeURIComponent(cityName)}`
  );
  const results = await response.json();
  if (results.length === 0) return null;

  const cityRef = {
    lat: parseFloat(results[0].lat),
    lon: parseFloat(results[0].lon)
  };

  const sorted = locations
    .map((addr) => ({
      ...addr,
      distance: getDistance(
        cityRef.lat,
        cityRef.lon,
        addr.lat,
        addr.lon
      )
    }))
    .sort((a, b) => a.distance - b.distance);

  return sorted.slice(0, 3);
}


async function fetchLocationsFromApi() {
  const response = await fetch("/api/locations/get-locations")
  const result = await response.json();

  if (!result.success) {
    throw new Error("Erreur backend");
  }

  return result.data.map((loc) => ({
    adresse: loc.address,
    lat: loc.latitude,
    lon: loc.longitude,
    region: loc.geoZoneName,
    name: loc.name,
    city: loc.city
  }));
}



export default function App() {
  const [city, setCity] = useState("");             // Ville saisie
  const [addresses, setAddresses] = useState([]);   // Sites internes trouvés
  const [loading, setLoading] = useState(false);    // Indicateur chargement
  const [errorMessage, setErrorMessage] = useState("");
  const [choice, setChoice] = useState("");         // Sélection du retour client
  const [suggestions, setSuggestions] = useState([]); // Suggestions Nominatim
  const debounceTimeout = useRef(null);

  const fetchCities = async (query) => {
    if (query.length < 2) return;

    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&limit=5&countrycodes=fr&q=${encodeURIComponent(query)}`
    );
    const data = await response.json();

    setSuggestions(
      data.map((item) => {
        const addr = item.address || {};
        const city =
          addr.city ||
          addr.town ||
          addr.village ||
          addr.hamlet ||
          item.display_name;

        const dept = addr.state || addr.county || "";
        return `${city}${dept ? " (" + dept + ")" : ""}`;
      })
    );
  };


const handleSearch = async () => {
  if (!city) return;

  setLoading(true);
  setErrorMessage("");

  try {
    const locations = await fetchLocationsFromApi();
    const closest = await findClosestAddresses(city, locations);

    if (!closest || closest.length === 0) {
      setAddresses([]);
      setErrorMessage("Aucun site trouvé à proximité.");
    } else {
      setAddresses(closest);
    }
  } catch (err) {
    setErrorMessage("Erreur lors de la récupération des sites.");
  }

  setLoading(false);
};


  const handleChangeCity = (e) => {
    const value = e.target.value;
    setCity(value);

    // --- annuler appel précédent si l'utilisateur tape vite ---
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

    debounceTimeout.current = setTimeout(() => {
      if (value.length >= 2) fetchCities(value);
    }, 200);
  };

  const handleChange = (e) => setChoice(e.target.value);

  const openRdvModal = (e, addr) => {
    if (e && e.preventDefault) e.preventDefault();
    const rdvBase = 'https://disc-rdv.oserlechangement.com/fr/oserlechangement';
    const rdvUrl = addr && addr.region
      ? `${rdvBase}/${encodeURIComponent(
        addr.region
          .normalize('NFD')              // décompose les caractères accentués
          .replace(/[\u0300-\u036f]/g, '') // supprime les accents
          .replace(/[^a-zA-Z0-9\s-]/g, '') // supprime caractères spéciaux
          .toLowerCase()
          .replace(/\s+/g, '-')           // remplace les espaces par des tirets
      )}`
      : rdvBase;


    const w = 900, h = 700;
    const left = (window.screenX || 0) + ((window.outerWidth || window.innerWidth) - w) / 2;
    const top = (window.screenY || 0) + ((window.outerHeight || window.innerHeight) - h) / 2;
    window.open(rdvUrl, 'rdvPopup', `width=${w},height=${h},left=${Math.max(0, left)},top=${Math.max(0, top)},resizable=yes,scrollbars=yes`);
  };

  const openRdvModalGeneral = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const rdvBase = 'https://disc-rdv.oserlechangement.com/fr/visio-expert';
    const w = 900, h = 700;
    const left = (window.screenX || 0) + ((window.outerWidth || window.innerWidth) - w) / 2;
    const top = (window.screenY || 0) + ((window.outerHeight || window.innerHeight) - h) / 2;
    window.open(rdvBase, 'rdvPopup', `width=${w},height=${h},left=${Math.max(0, left)},top=${Math.max(0, top)},resizable=yes,scrollbars=yes`);
  };

  // Rendre la fonction accessible globalement pour le lien HTML
  React.useEffect(() => {
    window.__openRdvModal = openRdvModalGeneral;
  }, []);

  const text2 = `🎯 SI CE N'EST PAS MAINTENANT :
- Je comprends totalement. Est-ce que vous pouvez me dire ce qui bloque encore pour vous ?
- Qu’est-ce que je peux vous apporter pour vous rassurer ou clarifier ce qui n’est peut-être pas encore tout à fait clair ?
- Si vous avez besoin de quelques jours, je vous propose qu’on fixe ensemble un petit point de suivi : 15 minutes dans 3 jours, par exemple.
- Et si ce n’est pas le bon moment aujourd’hui… quand serait-ce, selon vous ? (max 7j)
=> proposer d’envoyer un email avec une petite synthèse de l’échange, un lien pour aller sur la page des témoignages, et la brochure Oser le Changement.`


  const text3 = `💰 Si l’objection concerne le budget :
- En dehors de la question du budget, avez-vous le sentiment que cet accompagnement peut répondre à ce que vous recherchez ?
- Est-ce que vous pensez pouvoir y arriver seul(e) ou avec les solutions que vous avez déjà testées ?
- Si vous disiez “oui” aujourd’hui : qu’est-ce que vous y gagneriez concrètement ?
- Si le budget n’était pas un souci… est-ce que vous le feriez ?
- Selon vous, quelles seraient les pistes pour mobiliser les ressources nécessaires pour l’investissement de cet accompagnement ?
(Si nécessaire : expliquer que nous proposons des paiements en plusieurs fois sans frais, pour que ce soit plus accessible.)`

  const text4 = `⏱️ Si l’objection concerne le temps ou la disponibilité :
- Combien de temps pensez-vous pouvoir consacrer à ce programme d’accompagnement dès à présent ?
- Vous m’avez dit tout à l’heure que vous étiez à [x]/10 en termes d’engagement : comment pouvez-vous créer de la place pour y arriver ?
- Si ce n’est pas maintenant… alors quand serait-ce possible, réellement ? À quel moment ça deviendrait prioritaire pour vous ?`
  const text5 = `🤔 Si la personne dit “j’ai besoin de réfléchir” :
Bien sûr, je comprends.
Avant qu’on se quitte, pouvez-vous me dire : sur quels éléments exactement avez-vous besoin de prendre du recul ou de mûrir votre décision ?
Écouter. Relever les points. Répondre immédiatement si possible
=> ou proposer d’envoyer un email avec une petite synthèse de l’échange, un lien pour aller sur la page des témoignages, et la brochure Oser le Changement.`

  const text6 = `😶 Si la personne reste en hésitation :
- Qu’est-ce que vous risquez, au fond, à dire “oui” à cet accompagnement ? Qu’est-ce que vous risquez, au fond, en arrêtant votre à addiction à [substance] ?
- À quoi êtes-vous en train de dire non… si vous disiez oui ? (comprendre les peurs)
- Et selon vous, quelle serait la meilleure décision pour vous, là, maintenant ?
- Qu’est-ce qu’on fait ? On avance ensemble, ou vous préférez poser ça et y revenir dans quelques jours ?`
  const text7 = `✅ SI C’EST OUI :
Bravo 🙌
Ce premier pas est souvent le plus fort. Et je suis ravi(e) de pouvoir vous accompagner dans ce chemin vers [objectif spécifique de la personne].
Voici les prochaines étapes très concrètes :
 – Finalisation du paiement de la Séance de 3h + planification rdv
– Séance de Lancement (ou Séance Initiale) offerte à planifier 
Avez-vous des questions avant qu’on lance tout ça ensemble ?`
  const text8 = `
❌ SI CE N’EST PAS POUR MAINTENANT :
Aucun souci, l’important c’est que la décision soit juste pour vous.
Pour que je comprenne mieux :
 – Sur quoi avez-vous encore des doutes ?
 – Qu’est-ce qui pourrait vous rassurer, vous aider à décider plus sereinement ?
(Puis : répondre honnêtement, proposer témoignages ou ressources à lire)
Souhaitez-vous qu’on programme un rendez-vous de suivi dans 2 ou 3 jours ? (je vous propose un créneau de 15 minutes, comme ça on reste en lien)
Et si vous préférez réfléchir plus longuement, pas de souci :=> je vous enverrai un email avec une petite synthèse de l’échange, un lien pour aller sur la page des témoignages, et la brochure Oser le Changement., et je vous recontacterai d’ici 2-3 mois si c’est OK pour vous (je le note dans mon agenda).`
  const text = `- Est-ce que l’accompagnement serait pour vous ?
	- si oui, continuer les questions
	- si non, vérifier la situation
Votre proche est-il motivé à arrêter [son addiction] ? 
Si NON : 
On ne peut pas forcer quelqu’un à changer s’il n’en a pas envie. Tant qu’il n’y a pas ce déclic (cette prise de conscience, cette volonté réelle), aucun accompagnement ne peut être efficace. C’est comme essayer de faire pousser des fleurs sur un terrain sec et stérile : sans l’eau, rien ne germe.
En revanche, nous pouvons vous aider, vous.
En une vingtaine d’heures, nous pouvons vous accompagner pour mieux vivre la situation, retrouver une forme d’apaisement en vous-même, améliorer la relation avec votre proche et faire évoluer la dynamique familiale. En bougeant en vous, vous pouvez créer un espace qui, parfois, permet à l’autre de faire un pas.
Si OUI on continue.
<span >Si c’est pour une autre personne, proposer directement un appel avec elle ou à 3.</span>

- Quelle est votre situation professionnelle ? Et est-ce votre addiction a des répercussions sur votre travail ? ………..
Nous sommes un centre privé, spécialisé dans l’arrêt des addictions. Avez-vous consulté notre site et pris connaissance de nos tarifs ?
Nous avons un programme de 16 semaines pour vous libérer durablement de vos dépendances, sans prise en charge par la sécurité sociale, ni mutuelle. 
L’investissement s’élève à plusieurs milliers d’euros.
Est-ce que vous pouvez envisager cet investissement pour arrêter [......] ? 

- Est-ce que vous pouvez me parler de votre situation actuelle, en lien avec ce pour quoi vous nous contactez ?………..
<span>Par exemple pour faire détailler :</span>
 - Quelle est votre consommation actuelle (alcool, sucre, tabac, etc.) ?………..
 - À quelle fréquence ?………..
 - Depuis combien de temps ?………..
 - Y a-t-il eu des tentatives d’arrêt ou de contrôle ?………..
<span>SI c’est pour un proche : </span>
Et au-delà du comportement :
 - Qu’est-ce que vous ressentez face à ça ?………..
 - Qu’est-ce qui vous fait le plus souffrir aujourd’hui ?………..

<span>(Creuser doucement mais profondément :) </span>
 - Vous pouvez m’en dire un peu plus ?………..
 - Quand vous dites “je perds le contrôle”, qu’est-ce que ça signifie pour vous au quotidien ?………..
 - Est-ce que ça impacte vos relations ? Votre sommeil ? Votre estime de soi ? ………..

- Sur une échelle de 1 à 10, à quel point êtes-vous engagé.e à faire ce qu’il faut dès maintenant pour changer cela ? …/10
- Combien avez-vous prévu d’investir cette année pour [objectif ….] ? ………..
- Quel budget vous aviez vous prévu d’utiliser pour arrêter ? Comment pourriez-vous trouver les ressources nécessaires ?  (aide famille… ?) ………..

<span>D/ PROJECTION DANS LA SITUATION DÉSIRÉE (point B)</span>
- Maintenant, imaginons que dans 4 à 6 mois, cette difficulté soit résolue, (que vous soyez libéré de votre addiction à …)
- À quoi ressemblerait votre vie ? ………..
- Qu’est-ce qui aurait changé dans votre tête, dans votre corps, dans votre quotidien ? ………..
- Qu’est-ce que vous feriez de différent ? ………..
- En quoi ce changement serait important pour vous aujourd’hui ? ………..

<span>E/ CLARIFICATION DU PROBLÈME ET DE LA DOULEUR</span>
- Quelles solutions avez-vous déjà essayées pour vous sortir de cette situation ?
………..
- Qu'est-ce qui a marché ? Qu’est-ce qui n’a pas marché ? Qu’est-ce qui vous a manqué ?  ………..

- Et honnêtement… qu’est-ce qui se passe si rien ne change dans 6 mois ?
Dans votre vie perso ? Dans votre santé ? Dans vos relations ? Dans votre avenir (travail,, autres…) ? ………..………..…

<span>F/ REFORMULATION DE LA SITUATION, DES BLOCAGES ET DÉSIRS</span>
<span>=> Faire un récap de la situation + du problème + des blocages + du désir en utilisant les mots de la personne</span>
- Donc si je résume ce que vous m’avez dit que :
- Vous êtes confronté(e) à [résumer avec ses mots : dépendance, pulsions, isolement…]
- Vous avez déjà tenté [méthodes, tentatives, abstinence…]
- Et aujourd’hui, ce que vous voulez profondément, c’est [objectif formulé par la personne]
- Est-ce que j’ai bien compris ? Vous voulez ajouter quelque chose ? ……..……

<span>II - OFFRE (version courte)</span>
Merci pour votre confiance. Je pense sincèrement qu’on peut vous aider - parce qu’on a déjà accompagné des centaines de personnes dans des situations très proches de la vôtre.
Est-ce que je peux vous expliquer brièvement comment fonctionne notre programme, et voir si ça vous parle ?
(Attendre le “Oui”)
<span>A/ NOTRE APPROCHE
=> La promesse : </span>

Nous sommes un Centre privé, nous sommes là pour vous libérez-vous durablement de l’envie [de boire]. Grâce à la Méthode Activation Neuronale du Changement (A.N.C.).

<span>=> Bénéfices et résultat après le programme : </span>

Quand vous terminez le programme, vous n’êtes plus sous l’emprise de l’alcool. Vous êtes libre. Vraiment libre. Vous choisissez, vous ne subissez plus. Et la différence, vous la sentez tout de suite : plus d’énergie, plus de calme, l’esprit clair, recentré.

Votre visage change. Meilleur teint, regard plus vivant, ventre dégonflé. Vous avez meilleure mine… et surtout, vous vous sentez bien dans votre peau.

Et ce n’est pas que physique. Professionnellement, vous retrouvez votre énergie, votre efficacité. Vous avancez avec plus d’élan, plus de résultats. Vous reprenez confiance, vous reprenez le contrôle. Vos envies, vos décisions… redeviennent les vôtres.

Et vos relations suivent : plus de vraie connexion avec les autres, plus de joie, plus de présence. Votre entourage le voit, et vous le ressentez.

Mais le plus important ? C’est que vous redevenez vous-même. Et il n’y a rien de plus puissant que ça.


<span>=> La méthode + chiffres (5 000 personnes, taux rechute)</span>

Notre Méthode est sans médicament (permet de désactiver les vrais déclencheurs psychologiques (les blessures, les traumas, les schémas inconscients, la charge émotionnelle non digérée) ou qui viennent de votre environnement.

Nous avons déjà aidé + de 5 000 personnes à se libérer de l’addiction, depuis 2013.

Nos accompagnements sont personnalisés et affichent un taux de rechute inférieur à 2 %. 


<span>B/ COMMENT ÇA SE PASSE, CONCRÈTEMENT (les étapes) ? </span>

On valide ensemble un parcours complet sur 4 mois à raison d’une séance de 3h par semaine

Si vous avez des contraintes particulières, on peut adapter le rythme .Bien entendu vous avez du soutien entre les séances, votre praticien reste joignable.

Et on termine le programme avec une séance de debrief offerte pour clôturer.

=> Downsell si le prospect est motivé mais qu’il ne se sent pas suffisamment en confiance:
Ce que je peux vous proposer c’est de commencer par une séance de 3h test (330€) et de vous offrir une Séance de Lancement de Programme (ou Séance Initiale) à faire au préalable pour faire plus ample connaissance et mieux comprendre votre situation, se rendre compte s’il y a un ajustement  de la durée du programme à faire.


<span>C/ CE VOUS GAGNEZ AVEC LE PROGRAMME A.N.C.</span>
- Une méthode qui agit sur l’inconscient et désactive l’envie de boire à la racine

- Un programme 100 % personnalisé pour une transformation en profondeur

- Des techniques concrètes à réutiliser en autonomie, pour mieux gérer stress et émotions

- Des praticiens à vos côtés à chaque étape, même entre les séances si vous vous sentez mal (sms, WhatsApp, séance SOS)

- Un accompagnement que vous pouvez démarrer sous 72h, et suivre à votre rythme

- Des résultats souvent ressentis dès les premières séances : plus d’énergie, plus de calme

<span>D/ QUESTIONS D’ENGAGEMENT</span>
- Est-ce que tout ça vous parle ? ……..
- Qu’est-ce qui fait sens pour vous dans ce que je viens de décrire ? ……..
- Qu’est-ce qui vous donne envie d’avancer avec nous ? ……..
- Et si vous deviez me dire 3 raisons qui vous font dire “ce programme est fait pour moi”, ce serait quoi ? ……..
- Vous avez des questions ? ……..

<span>III - VALIDATION</span>
- Sur une échelle de 1 à 10, à combien vous pensez que cet accompagnement est fait pour vous et que vous avez envie de le faire ? Préciser que 7/10 est interdit avec humour (c’est la note pour ne pas se mouiller) …../10

<span>Si <9-10, dire :</span>
- Nous n'accompagnons que des personnes qui sont engagées et investies. C’est ça qui fait que les résultats arrivent vite.
- Du coup, pour comprendre : qu’est-ce qui vous manque pour être à 9 ou 10? ….
- Qu’est-ce que je pourrais vous apporter qui vous donne plus de clarté ? ….
<span>(ici creuser au max pour trouver les peurs, doutes et objections et y répondre avant de parler du tarif)</span>

<span>IV - CLOSING</span>
- L'investissement pour ce programme 4 mois en visio s’élève à 5 280€.
Attendre - ne surtout pas parler avant le prospect. Attendre la réaction 
- Bien évidemment, nous vous proposons un étalement en mensualité…
- Sachant que vous avez 5% de réduction si vous payez tout d’un coup 

<span>=> ne pas donner le tarif présentiel, que si le prospect le demande
=> si hésitation sur le tarif, creuser pour comprendre ce qui bloque
=> si ça bloque : proposer les tarifs praticien en cours de recrutement 3 696€ OU témoignage 4 224€ 
!!! Évitez de dire 48h, préférez : 4 mois (ou 16 semaines) à raison d’une séance de 3h par semaine</span>

<span>SI OUI  Programme 4 mois :</span>
Bravo. Ce premier pas est important, et je suis vraiment heureux(se) de pouvoir vous accompagner.
Voici les prochaines étapes :
 - <a href="https://disc-rdv.oserlechangement.com/fr/visio-expert" target="_blank" rel="noopener noreferrer" style={{ color: '#007bff', textDecoration: 'underline', fontWeight: 'bold' }} onclick="event.preventDefault(); window.__openRdvModal && window.__openRdvModal()">planifier la première S3H (séance de 3h)</a></span>

Super, ce qui nous reste à voir ensemble c’est le règlement, et une fois qu’on se sera occupés de ça on mettra en place les premières actions pour que tu puisses démarrer au + vite

<span>SI OUI  pour une SI + S3H test à 330€ :
- Paiement sécurisé de la 1ère séance de 3h (S3H), planifier
- planifier SI</span>
`


    ;

  return (
    <MdpProtection>
      <div className="txt" style={{ padding: "20px" }}>
        <div style={{ padding: "10px", marginBottom: "20px", lineHeight: "1.6" }}>
          <p>
            <span>I - DÉCOUVERTE<br />A/ ICEBREAKER</span><br />
            - Bonjour [Madame X / Monsieur X], merci pour ce temps ensemble aujourd’hui.
            Avant qu’on commence, j’aimerais juste vous demander : Comment allez-vous aujourd’hui ?
            Comment se passe votre semaine au niveau personnel ? ………..
            Comment ça se passe professionnellement pour vous en ce moment ?<br />
            - Comment avez-vous découvert notre accompagnement “Oser le Changement” ?
            <span>……Laisser parler. Rebondir avec une phrase empathique et créer un petit lien personnalisé</span><br />
            - Je comprends… vous n’êtes pas seul(e). Beaucoup de personnes qui nous contactent ont vécu exactement ça.
          </p>

          <p>
            <span>B/ CADRAGE<br />Donner l’objectif du call + Comprendre la situation et les objectifs du client</span><br />
            - Je vous explique comment va se dérouler notre appel. Mon but ici, c’est de comprendre : votre situation actuelle,
            ce qui vous freine, et ce que vous souhaitez changer.
          </p>

          <p>
            C/MOTIVATION / CONFIANCE
            <span>Questions démographiques :</span><br />
            âge <br /> situation familiale <br />
            ville :
            <input
              id="cityInput"
              list="cityList"
              value={city}
              onChange={handleChangeCity}
              placeholder="Tapez une ville"
              style={{ margin: "0 5px" }}
            />
            <button onClick={handleSearch}>Chercher</button>
          </p>
        </div>

        {/* --- Liste pour l'autocomplétion --- */}
        <datalist id="cityList">
          {suggestions.map((name, i) => (
            <option key={i} value={name} />
          ))}
        </datalist>

        <h3>Adresses les plus proches :</h3>
        {loading ? (
          <p>Recherche en cours...</p>
        ) : errorMessage ? (
          <p style={{ color: "red" }}>{errorMessage}</p>
        ) : (
          <ul>
            {addresses.map((addr, i) => {
              // Extraction du nom de la ville depuis l'adresse
              let ville = "";
              const match = addr.adresse.match(/\b([a-zA-ZÀ-ÿ\- ]+)(?:,|\d{5}|$)/gi);
              if (match && match.length > 0) {
                // Prend le dernier groupe qui ressemble à une ville
                ville = match[match.length - 1].trim();
              } else {
                ville = addr.adresse;
              }

              return (
                <li key={i}>
                  <a
                    href="https://disc-rdv.oserlechangement.com"
                    onClick={(e) => openRdvModal(e, addr)}
                    rel="noopener noreferrer"
                    style={{ color: '#007bff', textDecoration: 'underline', marginRight: 6, cursor: 'pointer' }}
                  >
                    Cabinet Oserlechangement de {ville}
                  </a>

                  : {addr.adresse} – {addr.distance.toFixed(2)} km
                </li>
              );
            })}
          </ul>
        )}


        {/* --- Bloc de texte scrollable --- */}
        <div style={{ whiteSpace: "pre-wrap", padding: "10px", marginBottom: "20px" }}>
          <div style={{ padding: "20px" }}>
            <div dangerouslySetInnerHTML={{ __html: text }} />
            <h2>Quel est le retour du client ?:</h2>
            <select value={choice} onChange={handleChange}>
              <option value="">--Sélectionner--</option>
              <option value="pas mtn">🎯 SI CE N’EST PAS MAINTENANT :</option>
              <option value="budget">💰 Si l’objection concerne le budget :</option>
              <option value="temps">⏱️ Si l’objection concerne le temps ou la disponibilité :</option>
              <option value="reflechire">🤔 Si la personne dit “j’ai besoin de réfléchir” :</option>
              <option value="hesitation">😶 Si la personne reste en hésitation :</option>
              <option value="oui">✅ SI C’EST OUI :</option>
              <option value="pas mtn2">❌ SI CE N’EST PAS POUR MAINTENANT :</option>
            </select>

            {choice === "pas mtn" && <p>{text2}</p>}
            {choice === "budget" && <p>{text3}</p>}
            {choice === "temps" && <p>{text4}</p>}
            {choice === "reflechire" && <p>{text5}</p>}
            {choice === "hesitation" && <p>{text6}</p>}
            {choice === "oui" && <p>{text7}</p>}
            {choice === "pas mtn2" && <p>{text8}</p>}
          </div>
        </div>
      </div>
    </MdpProtection>);
}